<template>
  <div id="slaves-settings">
    <div @click="open_lpr_devices_editor">
      <slot name="button">
        Open Slaves Editor
      </slot>
    </div>

    <v-dialog v-model="slaves_edit_dialog" :max-width="max_dialog_width">
    <v-card style="border-radius: 8px; display: flex; flex-wrap: wrap; justify-content: center" elevation="0">
      <v-card-title>
        {{ $i18n.t('pages.system.devices_network_settings.connected_devices_settings') }}
      </v-card-title>
      <v-card-text>
        <div>
          <v-tabs v-model="current_tab_index" style="margin-top: 15px;" background-color="transparent">
            <v-tab><span class="tab-font">{{ $i18n.t('pages.system.devices_network_settings.slaves_settings') }}</span></v-tab>
            <v-tab-item key="lpr_devices" class="rounded_8px">
                <v-card style="border-radius: 8px" id="lpr_devices_card" class="tab_card">
                  <v-card-text>
                    <v-data-table
                      :loading="table_loading"
                      :loading-text="$i18n.t('general.loading')"
                      style="letter-spacing: 0.25px;"
                      dense
                      :headers="slaves_table_headers"
                      :items="slave_devices_data"
                      :items-per-page="5"
                      :footer-props="{
                        itemsPerPageText: $i18n.t('table_footers.rows_per_page'),
                        itemsPerPageOptions: [5, 10, 20],
                      }"
                    >
                      <template #footer.page-text="props">
                      {{ $i18n.t('table_footers.some_rows_of_all', {some: `${props.pageStart}-${props.pageStop}`, all: `${props.itemsLength}`})}}
                      </template>

                      <template v-slot:item.name="{item}">
                          <span style="color: black">{{item.name}}</span>
                      </template>
                      <template v-slot:item.setup_link="{item}">
                        {{item.owner_fio}}
                      </template>
                      <template v-slot:item.connected="{item}">
                        <div>
                            <span v-if="item.connected"
                              style="height: 20px;
                                     width: 20px;
                                     background-color: #9c6;
                                     border-radius: 20px;
                                     display: inline-block;"
                            >
                            </span>
                            <span v-else
                              style="height: 20px;
                                     width: 20px;
                                     background-color: #fa4848;
                                     border-radius: 20px;
                                     display: inline-block;"
                            >
                            </span>
                         </div>
                      </template>
                      <template v-slot:item.actions="{item}">
                        <div style="display: flex; justify-content: flex-end">
                          <v-btn icon @click="delete_lpr_device(item)"><v-icon>$icon_trash</v-icon></v-btn>
                        </div>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
            </v-tab-item>
          </v-tabs>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
  </div>
</template>

<script>

import {common_funcs} from "@/mixins/common";
import {i18n} from "@/i18n";

export default {
  name: "SlavesSettings",
  mixins: [common_funcs],
  data: function () {
    return {
      table_loading: true,
      slaves_edit_dialog: false,
      max_dialog_width: '1200px',
      data_is_loaded: false,
      current_tab_index: 0,
      slaves_table_headers: [
        {
          text: i18n.t('pages.system.devices_network_settings.connected_devices_settings'),
          value: 'name', sortable: true, align: 'start'
        },
        {
          text: i18n.t('pages.system.devices_network_settings.device_serial'),
          value: 'serial'
        },
        {
          text: i18n.t('pages.system.devices_network_settings.connection_status'),
          value: 'connected', sortable: true, align: 'center'
        },
        {
          text: i18n.t('pages.system.devices_network_settings.actions'),
          value: 'actions', sortable: false, align: 'end'
        },
      ],
      slave_devices_data: [],
    }
  },
  methods: {
    fetch_lpr_devices_data: function () {
      this.$http({url: this.$http_hostname + '/lpr_devices/all', method: 'GET'})
      .then(resp => {
        this.slave_devices_data = resp.data.lpr_devices
        this.table_loading = false
      })
      .catch(error => {
        this.show_error_message(error)
        this.table_loading = false
      })
    },
    open_lpr_devices_editor: function () {
      this.fetch_lpr_devices_data()
      this.slaves_edit_dialog = true
    },
    delete_lpr_device: function (lpr_device) {
      let data = {'inner_id': lpr_device.inner_id}
      confirm(i18n.t('submissions.delete_lpr_device', {lpr_device_name: lpr_device.name})) &&
      this.$http({url: this.$http_hostname + '/lpr_devices/delete_by_inner_id', data: data, method: 'DELETE'})
      .then(resp => {
        console.log(resp)
        if (resp.data.result === 'ok') {
          console.log('ok')
          this.slave_devices_data.splice(
              this.slave_devices_data.indexOf(lpr_device), 1
          )
        } else {
          console.log('not ok')
        }
      })
      .catch(error => {
        this.show_error_message(error)
      })
    }
  },
  computed: {

  }
}
</script>

<style>

</style>